window.fancybox = require('@fancyapps/ui')